/* Generic product page: option chips resolve to a variant.

   Chips are per OPTION, not per variant. The harvesting tool is Micron by
   Colour, twelve variants across two axes, and a flat list of twelve would
   be unreadable. Picking a value on each axis and resolving the pair is both
   how people think about it and the only thing that scales.

   Prices come from the variant data Liquid rendered into the page. Nothing
   here decides what anything costs; the cart still settles that. */
(function () {
  'use strict';

  function init(root) {
    var data = root.parentNode.querySelector('[data-ak-prod-variants]') ||
               document.querySelector('[data-ak-prod-variants]');
    var variants = [];
    try {
      variants = JSON.parse(data.textContent);
    } catch (e) {
      return; /* without the data the server-rendered state is already correct */
    }

    var idField = root.querySelector('[data-ak-prod-id]');
    var priceEl = root.querySelector('[data-ak-prod-price]');
    var wasEl = root.querySelector('[data-ak-prod-was]');
    var addBtn = root.querySelector('[data-ak-prod-add]');
    var addLabel = root.querySelector('[data-ak-prod-add-label]');
    var mainImg = root.querySelector('[data-ak-prod-main]');
    var saveEl = root.querySelector('[data-ak-prod-save]');
    var groups = [].slice.call(root.querySelectorAll('[data-ak-prod-opt]'));
    var preorder = !!root.querySelector('.ak-note--warn');

    /* The format comes from the ELEMENT Liquid rendered the price into, not
       from Shopify.money_format, which is undefined on both AK storefronts.
       Falling back to a hardcoded dollar sign there is right on the US store
       by luck and wrong on AU, which prices in A$, and this picker repaints
       the price on every choice. */
    var format = (priceEl && priceEl.dataset.fmt) ||
                 (window.Shopify && Shopify.money_format) || '${{amount}}';

    function money(cents) {
      var whole = (cents / 100).toFixed(2).split('.');
      var withCommas = whole[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return format
        .replace(/\{\{\s*amount\s*\}\}/g, withCommas + '.' + whole[1])
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withCommas);
    }

    /* what the shopper has picked, in option order, with a null for any axis
       this product does not actually vary on */
    function chosen() {
      var out = [];
      groups.forEach(function (g) {
        var i = Number(g.dataset.akProdOpt);
        var hit = g.querySelector('[data-ak-prod-val]:checked');
        out[i] = hit ? hit.value : null;
      });
      return out;
    }

    function findVariant() {
      var want = chosen();
      return variants.filter(function (variant) {
        return want.every(function (val, i) {
          return val === null || val === undefined || variant.options[i] === val;
        });
      })[0] || null;
    }

    function apply() {
      var variant = findVariant();

      if (!variant) {
        // the combination does not exist at all, which is different from
        // existing and being out of stock, and should say so
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
        return;
      }

      if (idField) idField.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);

      var cut = variant.compare_at_price && variant.compare_at_price > variant.price;

      if (wasEl) {
        wasEl.hidden = !cut;
        if (cut) wasEl.textContent = money(variant.compare_at_price);
      }

      /* The saving is the reason a bundle exists, so it has to follow the
         choice rather than describe whichever variant happened to render. */
      if (saveEl) {
        saveEl.hidden = !cut;
        if (cut) {
          saveEl.textContent = (saveEl.dataset.tpl || 'Save [amount]')
            .replace('[amount]', money(variant.compare_at_price - variant.price));
        }
      }

      if (addBtn) addBtn.disabled = !variant.available;
      /* The three labels come down on the element, so the editor's wording
         survives a variant change instead of reverting to English written
         here. */
      if (addLabel) {
        var d = addLabel.dataset;
        addLabel.textContent = !variant.available
          ? (d.out || 'Sold out')
          : (preorder ? (d.pre || 'Pre-order') : (d.add || 'Add to cart'));
      }

      // a variant with its own photo should show it
      if (mainImg && variant.featured_image && variant.featured_image.src) {
        var next = variant.featured_image.src.split('?')[0] + '?width=1100';
        if (mainImg.getAttribute('src').split('?')[0] !== variant.featured_image.src.split('?')[0]) {
          mainImg.setAttribute('src', next);
          mainImg.removeAttribute('srcset');
        }
      }

      /* so a shared link lands on the same choice, and back/forward do not
         invent history entries for a colour swap */
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-ak-prod-val]')) apply();
    });

    /* ---- the add-on that follows the variant -----------------------------
       Liquid rendered a map of this product's variant ids to the add-on
       variant that pairs with each (same micron, same size). The offer is
       shown only when the chosen variant has a pair, and the tick sends the
       pair along as a second line in the same request as the main item,
       the way the hero's upgrade does: one POST, no half-added cart. */
    var addon = root.querySelector('[data-ak-prod-addon]');
    var addonMap = null;
    /* the map is rendered beside the variant data, outside the section root */
    var mapEl = root.parentNode.querySelector('[data-ak-prod-addon-map]') ||
                document.querySelector('[data-ak-prod-addon-map]');
    if (addon && mapEl) {
      try { addonMap = JSON.parse(mapEl.textContent); } catch (e) { addonMap = null; }
    }

    if (addon && addonMap) {
      var check = addon.querySelector('[data-ak-prod-addon-check]');
      var note = addon.querySelector('[data-ak-prod-addon-note]');
      var priceOut = addon.querySelector('[data-ak-prod-addon-price]');
      var qtyWrap = addon.querySelector('[data-ak-prod-addon-qtywrap]');
      var qtyIn = addon.querySelector('[data-ak-prod-addon-qty]');
      var noteTpl = addon.dataset.note || '';
      var outLabel = addon.dataset.outLabel || 'Out of stock';
      var current = null;

      function addonQty() {
        var n = parseInt(qtyIn && qtyIn.value, 10);
        return n > 0 ? n : 1;
      }

      function paintAddon() {
        if (!current) return;
        var n = check.checked ? addonQty() : 1;
        priceOut.textContent = current.available ? '+' + money(current.price * n) : outLabel;
        addon.classList.toggle('is-out', !current.available);
        qtyWrap.hidden = !(check.checked && current.available);
      }

      function syncAddon() {
        var variant = findVariant();
        current = variant ? addonMap[String(variant.id)] : null;
        if (!current) {
          addon.hidden = true;
          check.checked = false;
          return;
        }
        addon.hidden = false;
        check.disabled = !current.available;
        if (!current.available) check.checked = false;
        note.textContent = noteTpl.replace(/\[grade\]/g, current.grade);
        paintAddon();
      }

      check.addEventListener('change', paintAddon);
      addon.querySelectorAll('[data-ak-prod-addon-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          qtyIn.value = String(Math.max(1, addonQty() + (Number(btn.dataset.akProdAddonStep) || 1)));
          paintAddon();
        });
      });
      qtyIn.addEventListener('change', function () {
        qtyIn.value = String(addonQty());
        paintAddon();
      });
      root.addEventListener('change', function (e) {
        if (e.target.closest('[data-ak-prod-val]')) syncAddon();
      });

      var form = root.querySelector('form[action*="/cart/add"]');
      if (form) {
        form.addEventListener('submit', function (e) {
          if (!check.checked || !current || !current.available) return; // plain add
          var drawer = document.querySelector('ak-cart-drawer');
          if (!drawer || typeof drawer.addMany !== 'function') return; // let the form post
          e.preventDefault();
          e.stopPropagation();
          var qtyField = form.querySelector('[name="quantity"]');
          var qty = parseInt(qtyField && qtyField.value, 10);
          drawer.flyFrom(form);
          drawer.addMany([
            { id: Number(idField.value), quantity: qty > 0 ? qty : 1 },
            { id: Number(current.id), quantity: addonQty() }
          ], form.querySelector('[type="submit"]'));
        }, true);
      }

      syncAddon();
    }

    /* ---- gallery ---------------------------------------------------------
       Thumbs swap the main shot. No lightbox: the image is already large,
       and a modal here would be a second thing to dismiss on a phone. */
    /* The gallery may hold a drag to rotate object as well as photos. Only
       one of the two occupies the stage at a time, so a thumbnail click has
       to swap which is showing as well as which image is loaded. */
    var stage = root.querySelector('[data-ak-prod-stage]');
    var thumbs = [].slice.call(root.querySelectorAll('[data-ak-prod-thumb]'));
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var toSpin = btn.hasAttribute('data-ak-prod-spin-thumb');
        if (!toSpin) {
          if (!mainImg) return;
          mainImg.setAttribute('src', btn.dataset.full);
          mainImg.removeAttribute('srcset');
        }
        if (stage) {
          stage.classList.toggle('is-spin', toSpin);
          if (mainImg) mainImg.hidden = toSpin;
        }
        thumbs.forEach(function (t) { t.classList.toggle('is-on', t === btn); });
      });
    });

    apply();
  }

  function boot() {
    document.querySelectorAll('[data-ak-prod]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
